<script lang="ts">
	import type { AuthorPage } from '$models/Page/AuthorPage';
	import { page as routePage } from '$app/state';
	import BlogCard from '$components/Blog/BlogCard.svelte';
	import RelatedBlogsCarousel from '$components/Blog/RelatedBlogsCarousel.svelte';
	import AuthorHero from '$components/Page/AuthorHero.svelte';
	import { getSiteContext } from '$lib/context/site';
	import { jsonLdScriptTag } from '$lib/seo/jsonLd';
	import { buildProfilePageSchema } from '$lib/seo/schemas/person';

	let { page }: { page: AuthorPage } = $props();
	const site = getSiteContext();

	let authorSchemaHtml = $derived(
		jsonLdScriptTag(buildProfilePageSchema(page, new URL(routePage.url.pathname, site.url)))
	);
</script>

<svelte:head>
	{@html authorSchemaHtml}
</svelte:head>

<div class="block block--flex variant-tint-1">
	<div class="block__container container">
		<AuthorHero {page} />
	</div>
</div>

{#if page.highlightPost}
	<div class="block">
		<div class="block-container container">
			<BlogCard article={page.highlightPost} highlight />
		</div>
	</div>
{/if}

<div class="block">
	<div class="block-container container">
		<RelatedBlogsCarousel title={page.relatedPostsTitle} items={page.relatedPosts} />
	</div>
</div>
